import React, { Component } from 'react';
import { Container, Row, InputGroup, Col, Button, Table,Image, Form, DropdownButton, Dropdown, Modal,OverlayTrigger, Tooltip } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';
import Cards from 'react-credit-cards';
import SalirIcon from '../../../Images/salir.svg';

import NumberFormat from 'react-number-format';

import Connection from '../../../Calls';
import Backend from '../../../Backend';

import GAuth from '../../../Images/gauth.png'
import Contract from './contract';
import CardComponent from './Card';
import CardPlaceholder from '../../../Images/card-placeholder-white.svg';
import ShowPwd from '../../../Images/show.svg';
import HiddenPwd from '../../../Images/hidden.svg';

var pricesSocket;

class InvoicesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show2fa:false,
      bin_trunc:'',
      showModal:false,
      showPinModal:false,
      showContract:false,
      DataContract:{},
      Loading:false,
      cardImg: '',
      cardType: "unknown",
      disabled:true,
      showNumber: false,
    }
  }

  componentDidMount(){
    this.getContractInfo()
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.bin_trunc.length === 18 && this.state.bin_trunc.length === 19){
      this.requestDetectCard()
      this.setState({disabled: false});
    }
  }

  getContractInfo(){

    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });

    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.contract_card_info(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          this.setState({
            DataContract:response.payload
          })
        }
      });
    });
    
  }

  addNotification = (status,msg,type) => {
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true
      }
    });
  }


  getCardByNumber(e){
    const {value} = e.target;
    if (value !== '' && value.length > 0) {
      let mask = value.replace(/[^0-9]/g, '').replace(/(.{4})/g, '$1 ').trim();
      this.setState({bin_trunc: mask,  disabled: true});
    } else {
      this.setState({bin_trunc: value});
    }
  }


  requestDetectCard(){
    let bin_spaces = this.state.bin_trunc.replace(/[^0-9]/g, '')
    console.log("bin_spaces", bin_spaces);
    let whiskas = Connection.RThzHrsb(bin_spaces);
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    let combination2 = Connection.RThzHrsb("XWBX203")
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var charly = response.payload.r01;
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", whiskas, response => {
        Backend.DetectCardType(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r03,  charly, response => {
          if (response.status.code == '0'){
            this.setState({
              cardImg: response.payload.image,
              cardType: response.payload.type            
            })
          }
        })

      })
    })

  }




  _verifyCard(){


    const self = this;
    // && this.state.tagIdW !== ""

    self.setState({ showload: true });

    if (this.state.bin_trunc !== '') {
      let bin_spaces = this.state.bin_trunc.replace(/\s/g, '')
      console.log("bin_spaces", bin_spaces);
      let whiskas = Connection.RThzHrsb(bin_spaces);

      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
      let combination2 = Connection.RThzHrsb("XWBX203")
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;
      Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        var charly = response.payload.r01;
        Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "1", whiskas, response => {
          Backend.VerifyCard(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r03,  charly, response => {
            if (response.status.code === "0") {
              store.addNotification({
                title: "Success!",
                message: 'Card registered correctly',
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true
                }
              });
              self.setState({
                showload: false,
                showModal:false,
                showPinModal:false,
                showContract:true,
                pin:response.payload.pin
              });
            }else{

                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
                self.setState({
                  showload: false,
               });
            }
          })
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({
        showload: false,
      });
    }
  }

  uploadContract(contract){
    this.setState({Loading:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
    });

    result = latitude + longitude;

    let file ={
      base64Type:'pdf',
      base64:contract
    }

    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
        Backend.upload_file(localStorage.getItem('email'), localStorage.getItem('token'),file,'f_contract_card',response.payload.r01, response => {
    
          if (response.status.code === "0"){
            this.addNotification("Success!",response.payload.message,"success");
            this.setState({showContract:false, Loading:false})
            this.props.GetStatusCard()
          }else{
            this.addNotification("Error!",response.status.description,"danger");
          }
        });
    });
  }

  render() {
    return (
      <>
        <div className="contenedor-wallets-generals">
          <div className='container-withouth-data-wallets'>
            <div>
            <p className="title-withouth-data-wallets">{this.props.traductions.Card.assignation.title}</p>
            <center>
              <Button onClick={() => { this.setState({showModal:true}) }} className="signup-button" variant="primary">
                {this.props.traductions.Card.assignation.btn}
              </Button>
            </center>
            </div>
          </div>
        </div>


        <Contract show={this.state.showContract} handleClose={()=>this.setState({showContract:false})} data={this.state.DataContract} uploadContract={(contract) => this.uploadContract(contract)} Loading={this.state.Loading}/>

        <Modal centered show={true} onHide={()=>{this.setState({showModal:false})}}>
          <div style={{textAlign: 'end', padding: '10px 15px 0px'}}>
            <Image src={SalirIcon} onClick={() => this.props.data.history.push('/')} width={15} style={{cursor: 'pointer'}} />
          </div>
          <Modal.Body style={{padding: '10px 70px 70px'}}>
            <center style={{marginBottom:30}}>
              {
                this.state.cardType === 'unknown' ? 
                <Image src={CardPlaceholder} width={188} height={115}/>
                  :
                <Image src={`data:image/jpeg;base64,${this.state.cardImg}`} width={188} height={115}/>
              }
            </center>
            <div className="border-title-separator-container">

              <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                <span className='add-card-title'>{this.props.traductions.Card.assignation.M1_title}</span>
              </div>
            </div>
            <div className="steps-add-wallet-general">
              <Form.Group as={Row}>
                <Col>

                  <Form.Label className="label-card-register">{this.props.traductions.Card.assignation.M1_L_input}</Form.Label>

                  <Form.Control
                    type={this.state.showNumber ? "text": "password" }
                    value={this.state.bin_trunc}
                    placeholderText='#CCD5E2'
                    onChange={(e) => this.getCardByNumber(e)}
                    maxLength={19}
                  
                  />
                  <img src={this.state.showNumber ? HiddenPwd : ShowPwd} className="eye-icon" onClick={() => this.setState({showNumber: !this.state.showNumber})}/>
                </Col>
              </Form.Group>
            </div>
            <div style={{ marginTop: 20, textAlign: "center" }}>
              <Button style={{width: '100%'}} onClick={() => { this._verifyCard() }} className={this.state.disabled ? "btn-registry-disabled" : "signup-button"} variant="primary" disabled={this.state.disabled || this.state.showload}>

                {
                  (this.state.showload)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                  : this.props.traductions.Card.assignation.M1_btn
                }
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        {/* <Modal centered show={this.state.showPinModal} onHide={()=>{this.setState({showPinModal:false});this.props.GetStatusCard()}}>
          <Modal.Body>
            <div style={{marginBottom:30}} className="border-title-separator-container">
              <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                <p className="title-container-shadow">{this.props.traductions.Card.assignation.M2_title}</p>
              </div>
            </div>
            <p className="pin-text">{this.props.traductions.Card.assignation.M2_PinNote}: </p>
            <p className='pin-number'> {this.state.pin}</p>
            <div style={{ marginTop: 30, textAlign: "center" }}>
              <Button onClick={()=>{this.setState({showPinModal:false, showContract:true});}} className="signup-button" variant="primary">
                OK
              </Button>
            </div>
          </Modal.Body>
        </Modal> */}
      </>
    );
  }

}

export default InvoicesIndex;
